import { ReduxActions } from '@src/redux/actions/interfaces/action.interface';
import { NoticeActions } from '../../actions/notice/notice.enum';
import { NoticeState } from './notice.interface';

const { NOTICE_SET, SET_NOTICE_LOADING } = NoticeActions;

const DEFAULT_STATE = {
  isLoading: false,
  notice: undefined,
};

export function notice(state = DEFAULT_STATE, action: ReduxActions): NoticeState {
  switch (action.type) {
    case SET_NOTICE_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case NOTICE_SET:
      return {
        ...state,
        isLoading: false,
        notice: action.payload.notice,
      };
    default:
      return state;
  }
}
